import { Directive, ElementRef, EventEmitter, Input, NgZone, Output } from '@angular/core';
import { ReorderableRow, Table } from 'primeng/table';

@Directive({
  standalone: true,
  selector: '[pReorderableRowDrop]'
})
export class ReorderableRowDropDirective extends ReorderableRow {
  @Input() public set pReorderableRowDrop(value: number) {
    this.index = value;
  }

  @Output() public dropRow = new EventEmitter<any>();

  public constructor(public override dt: Table, public override el: ElementRef, public override zone: NgZone) {
    super(dt, el, zone);
  }

  public onDrop(event: any) {
    if (this.isEnabled() && this.dt.rowDragging) {
      const eventArgs = {
        draggedRowIndex: this.dt.draggedRowIndex,
        droppedRowIndex: this.dt.droppedRowIndex
      };

      super.onDrop(event);
      this.dropRow.emit(eventArgs);
    }
  }
}
